/**
 * Environment configuration and helpers based on hostname
 */

const hostname = window.location.hostname;
const port = window.location.port;

export const isLocalhost =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname.startsWith("192.168.") ||
  (hostname === "localhost" && port === "8080");

export const isHomologation =
  hostname.includes("dev-portal.b2b2c.lex.education") ||
  hostname.includes("staging");

export const isDevelopmentEnvironment = isLocalhost || isHomologation;

// Permite validar telas locais sem redirecionar para o provedor OIDC. A checagem de hostname
// impede que a variável produza bypass em homologação ou produção.
export const isLocalAuthBypassEnabled =
  isLocalhost && import.meta.env.VITE_LOCAL_AUTH_BYPASS === "true";

export const APP_ENV = isLocalhost
  ? "localhost"
  : isHomologation
    ? "homologation"
    : "production";

export const ENV_CONFIG = {
  APP_ENV,
  isLocalhost,
  isHomologation,
  hostname,
  version: "1.0.0",
};

export default ENV_CONFIG;
